module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result09-513d17d619aa44307a3f35b42f02043c.png";